import api from "../../index";

export const GetAllUserApi = (params) => api.get(`Admin/Get-All-Support-User?${params}`);
export const AddUserApi = (data) => api.post(`Admin/User-Register`, data);
export const UpdateUserStatusApi = (data) => api.put('Admin/Active-DeactiveUser', data);